import { render } from "./AdditionalInfo.vue?vue&type=template&id=13adc3db&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=13adc3db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13adc3db"]])

export default __exports__